import React, { useState } from "react";
import styles from "./CreateNewMaterial.module.css";
import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { Dropdown, InputField, TextComponent, SubmitButton } from "../../../../../components";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";

const CreateNewMaterial = () => {
  const navigate = useNavigate();


  const [ingredientName, setIngredientName] = useState("Carton Box");
  const [currentStock, setCurrentStock] = useState(2);
  const [unitOfMeasure, setUnitOfMeasure] = useState({
    value: "Unit",
    id: 0,
  });
  const [lowStockThreshold, setLowStockThreshold] = useState(0.5);
  const [category, setCategory] = useState({
    value: "Category",
    id: 0,
  });
  const [notes, setNotes] = useState("notes");


  const handleSubmit = () => {
    const formData = {
      Ingredient_Name: ingredientName,
      Current_Stock: currentStock,
      Unit_Of_Measure: unitOfMeasure.value,
      Low_Stock_Threshold: lowStockThreshold,
      Category: category.value,
      Notes: notes,
    };
    if (ingredientName === "" || currentStock === "" || lowStockThreshold === "" || notes === "" || unitOfMeasure.id === 0 || category.id === 0) {
      alert("Please fill in all fields.");

    } else {
      navigate("/Warehouse/AdjustStock", { state: formData });
    }
  };

  return (
    <div className={styles.mainCont}>

      <div className={styles.subCont}>

        <HeaderComponent
          heading={" Add Material "}
          showBackIcon={true}
        // showFilterIcon={true}
        // showSubmitButton={true}
        // showSearch={true}
        />

        <div className={styles.row}>
          <InputField
            className={styles.inputNew}
            label={"Material Name"}
            placeholder={"Cake Boards"}
            value={ingredientName}
            onChange={(e) => setIngredientName(e.target.value)}
          />
          <Dropdown
            inputStyle={{
              backgrounndColor: '#F7F8F9'
            }}
            className={styles.inputNew}
            label={"Unit of Measure"}
            value={unitOfMeasure}
            style={{ color: "var(--black-color)" }}
            options={[
              { value: "Pcs", id: 1 },
              // { value: "Lbs", id: 2 },
              // { value: "Liters", id: 3 },
            ]}
            onChange={(e) => setUnitOfMeasure(e)}
          />
        </div>
        <div className={styles.row}>
          <InputField
            className={styles.inputNew}
            label={"Current Stock Level"}
            placeholder={"02"}
            value={currentStock}
            onChange={(e) => setCurrentStock(e.target.value)}
            type={"number"}
          />
          <InputField
            className={styles.inputNew}
            label={"Low Stock Threshold"}
            placeholder={"0.5"}
            value={lowStockThreshold}
            onChange={(e) => setLowStockThreshold(e.target.value)}
            type={"number"}

          />
        </div>

        <div className={styles.row}>
          <Dropdown
            className={styles.inputNew}
            label={"Category"}
            value={category}
            style={{ color: "var(--black-color)" }}
            options={[
              { value: "Packaging", id: 1 },
              { value: "Sanitory", id: 2 },
              { value: "Utensils", id: 3 },
            ]}
            onChange={(e) => setCategory(e)}
          />
          <InputField
            className={styles.inputNew}
            label={"Notes"}
            labelClass={styles.labelClass}
            placeholder={"e.g., preferred vendor, storage instructions"}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className={styles.btnContainer}>
          <SubmitButton
            title={"Add Material"}
            primary
            onClick={handleSubmit}
            btnClass={styles.Login_btn}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateNewMaterial;
